import type { ComponentType } from 'react'

import type { ListShipment } from '@fv/client-types'
import type { ColumnPreference, ShipmentSortType } from '@fv/models'

export type CellProps = { load: ListShipment }

export type ColumnRegistryEntry = {
  label: string
  sortable?: boolean
  sortBy?: ShipmentSortType
  Cell: ComponentType<CellProps>
}

export const defaultColumnPreferences: ColumnPreference[] = [
  { id: 'tracking', visible: true },
  { id: 'status', visible: true },
  { id: 'carrier', visible: true },
  { id: 'origin', visible: true },
  { id: 'pickup', visible: true },
  { id: 'destination', visible: true },
  { id: 'delivery', visible: true },
  { id: 'mode', visible: true },
]
